export const ASSET_LIBRARY_PATH = "/context-hub/assets/library";
export const CATALOG_PATH = "/context-hub/assets/catalog";
